<div class="product-detail-page section-gap bg-white" >
    <div class="container">
      <div fxLayout='row wrap' fxLayoutAlign="center center" class="col-gap">
        <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md=90 fxFlex.lg="80" fxFlex.xl="90">
          <div fxLayout='row wrap' class="col-gap position-relative">
            <mat-card fxFlex.xs="100" fxFlex.sm="100" fxFlex.md=50 fxFlex.lg="50" fxFlex.xl="50"  class="relative" style="width: 100%; height: 500px; ">
              <div fxLayout='row wrap'>
                 <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100" class="relative">
                  <carousel class="carousel slide container" style="width: 100%; height: 400px; ;margin: 0 auto" *ngIf="farm?.fileRoots">
                    <slide *ngFor="let img of farm?.fileRoots">
                      <a [href]="getUrlImage(img.fileRoot)">
                        <img [src]="getUrlImage(img.fileRoot)"alt="Not found" style="width: 100%; height: 400px; ;margin: 0 auto">
                     </a>
                    </slide>
                  </carousel>
                  <img src="assets/images/image-not-found.png" alt="Not found" style="width: 100%; height: 400px; ;margin: 0 auto" *ngIf="farm?.fileRoots.length==0">
                </div>
              </div>
            </mat-card>
            <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md=50 fxFlex.lg="50" fxFlex.xl="50">
              <div class="product-detail-content">
                <span class="back-farms"> <a  [routerLink]="['/']">{{ 'FARM.BACK_FARMS' | translate }}</a></span>
                <h4>{{ 'FARM.INFO_FARM' | translate }}</h4>
                <ul class="no-style mb-4">
                  <li>
                    <strong><span class="font-medium"> {{ 'FARM.AVAILABLITY.AVAILABLITY' | translate }} </span></strong>: 
                      <span *ngIf="farm?.available">{{ 'FARM.AVAILABLITY.YES' | translate }}</span>
                      <span *ngIf="!(farm?.available)">{{ 'FARM.AVAILABLITY.NO' | translate }}</span>
                  </li>
                  <li>
                    <strong><span class="font-medium">{{ 'FARM.CODE' | translate }} </span></strong>: {{farm?.id}}
                  </li>
                  <li>
                    <strong><span class="font-medium">{{ 'REGISTER.MOBILE_NUMBER' | translate }} </span></strong>: {{farm?.numberPhone}}
                  </li>
                </ul>
                <div class="short-des">
                  <h6>{{ 'FARM.INFO_FARM' | translate }}</h6>
                  <p>{{farm?.information}}
                  </p>
                </div>
                <div class="bullets-points">
                  <ul class="bullets-list">
                    <h6>{{ 'FARM.DESITE_TO.DESITE_TO' | translate }}</h6>
                    <li *ngFor="let exp of farm?.exploitations">
                      {{'FARM.DESITE_TO.TYPE.' + exp | uppercase | translate }}
                    </li>
                  </ul>
                </div>
                <div class="bullets-points">
                  <ul class="bullets-list">
                    <h6>{{ 'FARM.OBJECTIVES_TO.OBJECTIVES_TO' | translate }}</h6>
                    <li *ngFor="let obj of farm?.objectives">
                      {{'FARM.OBJECTIVES_TO.TYPE.' + obj | uppercase | translate }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  